import { render, staticRenderFns } from "./InspectionShipment.vue?vue&type=template&id=550c1a84&scoped=true&"
import script from "./InspectionShipment.vue?vue&type=script&lang=js&"
export * from "./InspectionShipment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "550c1a84",
  null
  
)

export default component.exports